import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { CRM_HD_CONFIG } from "./crm-detail-content";
import { ProductDetailHdPage } from "./ProductDetailHdPage";

export interface CrmProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** CRM HD page — shared ProductDetailHdPage + CRM content/assets. */
export function CrmProductDetailHd(props: CrmProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={CRM_HD_CONFIG} />;
}
